import React, {useState, useEffect} from 'react';
import Notify from '../Notify';
import Time from '../Time';
import Permissions from '../Permissions';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'

class RequestVacation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        startDateTime:"",
        finishDateTime:"",
        reason:"",
        message:"",
        vacationDays:0,
        vacationDates:[],
        holidays:[]
    };
   
    this.handleFormTimeChange = this.handleFormTimeChange.bind(this);
    this.requestVacation = this.requestVacation.bind(this);
    this.getGroups = this.getGroups.bind(this);
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
  }

  componentDidMount(){
    this.getOntarioHolidays();
    this.getGroups();
  }

  getGroups = async() =>{
    let groupsWhoWillReceiveNotification = "Admin,HR";
    let group = await Permissions.getPermissionGroups(groupsWhoWillReceiveNotification);
    console.log(group)
  }


  getOntarioHolidays = async() =>{
    let APIOntarioholidays = await Time.getHolidays();
    this.setState({holidays:APIOntarioholidays});
  }

  /**
   * Check if that date is a Holiday
   * @param  {} vacationDay
   * @return true or false
   */
  checkHoliday(vacationDay){
    let vacationDate = Time.makeNormalDateToServer(vacationDay);
    let holidays = this.state.holidays
    let result = false;
    for(let holiday of holidays){
        if(vacationDate == holiday.observedDate){
            result = true;
        }
    }

    return result;
    
  }

  handleFormTimeChange = (e) =>{

    //
    this.setState({[e.target.id]: e.target.value});

    //We just set hours for the dates to avoid errors on calculation
    let startingDate = new Date(this.startDateRef.current.value+"T00:00:00");
    let finishDate = new Date(this.endDateRef.current.value+"T01:00:00");

    //gets the number of days
    let numberOfDays = Math.floor((finishDate-startingDate)/86000000)+1;

    let initialDate = startingDate;
    let datesList=[];
    //Generate Vacation Days
    for (let i = 0; i < numberOfDays; i++) {
        let vacationDate = initialDate;

            //Check for weekends on this vacation
        if (vacationDate.getDay() == 0 || vacationDate.getDay() == 6){    
            console.log("Weekend Found!");
            initialDate.setDate(initialDate.getDate() + 1);
            
            //Check for holidays on this vacation
        }else if(this.checkHoliday(vacationDate)){
            console.log("Holiday Found!");
            initialDate.setDate(initialDate.getDate() + 1);
        }else{
            //If nothing is wrong it adds this date to the list
            datesList.push(Time.makeNormalDateToServer(vacationDate))
            initialDate.setDate(initialDate.getDate() + 1);
        }

        this.checkHoliday(vacationDate);
        
    }
    
    //calculates how many days of vacation it will be according to the selected dates
    let NumberOfdaysOfVacation = datesList.length;

    console.log(datesList)
    this.setState({vacationDates:datesList})
    this.setState({vacationDays:NumberOfdaysOfVacation})

  }

  /**
   * Send the request to the database
  */
  requestVacation = (e) =>{
    e.preventDefault();

    let user = this.props.user
    let startDate = this.state.startDateTime
    let finishDate = this.state.finishDateTime
    let numberOfDays = this.state.vacationDays
    let vacationDates = this.state.vacationDates
    let reason = this.state.reason
    
    //Checks if the user selected valid dates
    if(this.state.vacationDays <= 0){
        this.setState({message:"You need to select valid dates"})
        return;
    }

    var formdata = new FormData();
    formdata.append("username", user);
    formdata.append("startTimeDate", startDate);
    formdata.append("endTimeDate", finishDate);
    formdata.append("reason", reason);
    formdata.append("dates", vacationDates);
    formdata.append("numDays", numberOfDays);
    formdata.append("requestDate", Time.getComputerTimeDate());
    

    var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/payroll/requestvacation.php", requestOptions)
    .then(response => response.text())
    .then(result => this.props.close())
    .catch(error => console.log('error', error));

    }

  render() {
   
    return(
        <div>
            <div className='pop-up' style={{zIndex: 9999}} onClick={this.props.close}></div>
            <div className="container pop-up-window" style={{zIndex: 9999}}>
                <div className="row">
                    <div className="col-12 container p-4">
                        <h1>Vacation request</h1>          
                    </div>
                    <form onSubmit={this.requestVacation}>
                        <div className='row'>
                            <div className='col-6'>
                                <div className="mb-3">
                                    <label className="form-label">Start Date and Time</label>
                                    <input ref={this.startDateRef} onChange={this.handleFormTimeChange} type="date" className="form-control" id="startDateTime" required></input>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="mb-3">
                                    <label className="form-label">Finish Date and Time</label>
                                    <input ref={this.endDateRef} onChange={this.handleFormTimeChange} type="date" className="form-control" id="finishDateTime" required></input>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className="mb-3">
                                    <label className="form-label">Reason</label>
                                    <textarea onChange={this.handleFormTimeChange} className="form-control" rows="5" id="reason" required></textarea>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="mb-3">
                                    <button>Submit</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className='col-12'>
                        <div className="mb-3">
                            <p>Total of days: {this.state.vacationDays}</p>
                            <p className='text-center'>{this.state.message}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default RequestVacation;